module.exports = __webpack_public_path__ + "static/media/minimize.393d1460.svg";